import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TegelModule } from '@scania/tegel-angular-17';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { ToastComponent } from './shared/components/toast/toast.component';
import { SideMenuComponent } from './core/components/side-menu/side-menu.component';
import { HeaderComponent } from './core/components/header/header.component';
import { FooterComponent } from './core/components/footer/footer.component';
import { LoadingService } from './shared/services/loading.service';
import { MsalService } from '@azure/msal-angular';
import { UserService } from './core/services/user.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    TegelModule,
    HeaderComponent,
    SideMenuComponent,
    FooterComponent,
    ToastComponent,
    SpinnerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements AfterViewInit {
  public isTotemRoute: boolean = false;
  loading = false;
  public loadingService = inject(LoadingService);
  private readonly authService = inject(MsalService);
  private readonly userService = inject(UserService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly router = inject(Router);

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.isTotemRoute = event.urlAfterRedirects.includes('/totem');
      });
  }

  ngOnInit(): void {
    this.authService.handleRedirectObservable().subscribe({
      next: () => {
        const accounts = this.authService.instance.getAllAccounts();
        if (accounts.length == 0) {
          this.authService.initialize().subscribe({
            next: () => {
              this.authService.loginRedirect();
            },
          });
        } else {
          const account =
            this.authService.instance.getAllAccounts()[0].idTokenClaims!;
          this.userService.setRoles(account.roles!);
          this.userService.setUser(account.name!, account.preferred_username!);
        }
      },
    });
  }

  ngAfterViewInit(): void {
    this.loadingService.loading$.subscribe((value) => {
      this.loading = value;
      this.cdr.detectChanges();
    });
  }
}
